import axios from 'axios'

import { Message, MessageBox } from 'element-ui'

import { APP_API_BASE } from '@/utils/api-base'



const H5_ADMIN_TOKEN_KEY = 'h5_admin_token'

const H5_ADMIN_USER_KEY = 'h5_admin_user'

const SCHOOLS_ACTIVE_ORG_ID_KEY = 'schools_active_org_id'

const SCHOOLS_ORG_HEADER = 'X-School-Org-Id'



let reloginPromptVisible = false



const adminRequest = axios.create({

  baseURL: APP_API_BASE,

  timeout: 15000

})



export function getH5AdminToken() {

  try {

    const raw = window.localStorage.getItem(H5_ADMIN_TOKEN_KEY)

    return raw != null ? String(raw).trim() : ''

  } catch (e) {

    return ''

  }

}



export function setH5AdminToken(token) {

  try {

    if (token) {

      window.localStorage.setItem(H5_ADMIN_TOKEN_KEY, token)

    } else {

      window.localStorage.removeItem(H5_ADMIN_TOKEN_KEY)

    }

  } catch (e) {

    // ignore

  }

}



export function clearH5AdminToken() {

  setH5AdminToken('')

}



export function getSchoolsActiveOrgId() {

  try {

    const raw = window.sessionStorage.getItem(SCHOOLS_ACTIVE_ORG_ID_KEY)

    if (raw == null || raw === '') return null

    const n = Number(raw)

    return Number.isFinite(n) && n > 0 ? n : null

  } catch (e) {

    return null

  }

}



export function setSchoolsActiveOrgId(orgId) {

  try {

    if (orgId != null && orgId !== '') {

      window.sessionStorage.setItem(SCHOOLS_ACTIVE_ORG_ID_KEY, String(orgId))

    } else {

      window.sessionStorage.removeItem(SCHOOLS_ACTIVE_ORG_ID_KEY)

    }

  } catch (e) {

    // ignore

  }

}



export function clearSchoolsActiveOrgId() {

  setSchoolsActiveOrgId(null)

}



function clearH5AdminSessionLocal() {

  clearH5AdminToken()

  try {

    window.sessionStorage.removeItem(H5_ADMIN_USER_KEY)

    window.sessionStorage.removeItem(SCHOOLS_ACTIVE_ORG_ID_KEY)

  } catch (e) {

    // ignore

  }

}



function isAdminLoginRoute() {

  const hash = window.location.hash || ''

  return hash.indexOf('/admin/login') >= 0

}



function redirectToAdminLogin() {

  clearH5AdminSessionLocal()

  const hash = window.location.hash || ''

  const currentPath = hash.replace(/^#/, '') || '/admin/home'

  const redirectQuery = currentPath.startsWith('/admin/login')

    ? ''

    : `?redirect=${encodeURIComponent(currentPath)}`

  window.location.replace(`${window.location.pathname}${window.location.search}#/admin/login${redirectQuery}`)

}



function handleUnauthorized() {

  if (reloginPromptVisible || isAdminLoginRoute()) {

    return

  }

  reloginPromptVisible = true

  MessageBox.confirm(

    '登录状态已过期，您可以继续留在该页面，或者重新登录',

    '系统提示',

    {

      confirmButtonText: '重新登录',

      cancelButtonText: '取消',

      type: 'warning',

      closeOnClickModal: false

    }

  ).then(() => {

    redirectToAdminLogin()

  }).catch(() => {

    reloginPromptVisible = false

  })

}



function isUnauthorizedPayload(data) {

  if (!data || typeof data !== 'object') return false

  return data.status === 401 || data.code === 401

}



adminRequest.interceptors.request.use(

  config => {

    if (!(config.data instanceof FormData)) {

      config.headers['Content-Type'] = 'application/json'

    }

    const token = getH5AdminToken()

    if (token && token !== 'null' && token !== 'undefined') {

      config.headers['H5-Admin-Authorization'] = token

    }

    const orgId = getSchoolsActiveOrgId()

    if (orgId) {

      config.headers[SCHOOLS_ORG_HEADER] = String(orgId)

    }

    return config

  },

  error => Promise.reject(error)

)



adminRequest.interceptors.response.use(

  response => {

    if (response.config && response.config.responseType === 'blob') {

      return response.data

    }

    const res = response.data

    if (isUnauthorizedPayload(res)) {

      handleUnauthorized()

      return Promise.reject(new Error((res && res.msg) || '登录状态已过期'))

    }

    if (res && res.success === false) {

      const msg = res.msg || '请求失败'

      Message.error(msg)

      return Promise.reject(new Error(msg))

    }

    return res

  },

  error => {

    if (error.response) {

      const data = error.response.data

      if (error.response.status === 401 || isUnauthorizedPayload(data)) {

        handleUnauthorized()

        return Promise.reject(error)

      }

    }

    let msg = '网络异常'

    if (error.response && error.response.data && error.response.data.msg) {

      msg = error.response.data.msg

    } else if (error.code === 'ERR_NETWORK' || (error.message && error.message.indexOf('Network Error') >= 0)) {
      const isProd = typeof APP_API_BASE === 'string' && /^https:\/\//i.test(APP_API_BASE)
      msg = isProd
        ? '无法连接后端服务，请检查网络或联系管理员（API: ' + APP_API_BASE + '）'
        : '无法连接后端服务，请确认 crm-app 已启动（端口 8223）'

    } else if (error.message) {

      msg = error.message

    }

    Message.error(msg)

    return Promise.reject(error)

  }

)



export default adminRequest

